import AreaTemplate from '@/templates/AreaTemplate';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Cookies } from 'react-cookie';

export default function AreaContainer() {
  const location = useLocation();
  useEffect(() => {
    const queryParam = new URLSearchParams(location.search);
    const connectSid = queryParam.get('connect.sid');
    const cookie = new Cookies();
    cookie.set('connect.sid', connectSid, { path: '/' });
  }, [location.search]);
  return <AreaTemplate />;
}
